import { EPromptOptimizationAlgorithm } from '@/types/schema';

import { PromptimConfig } from './PromptimConfig';
import { ModalButtons } from './Shared';

export const AlgorithmConfig = ({
  algorithm,
  isOptimizeLoading,
  onClose,
  prevStep,
}: {
  algorithm: EPromptOptimizationAlgorithm;
  isOptimizeLoading: boolean;
  onClose: () => void;
  prevStep: () => void;
}) => {
  const renderAlgorithmConfig = () => {
    switch (algorithm) {
      case EPromptOptimizationAlgorithm.DEMO:
        return <DemoConfig />;
      case EPromptOptimizationAlgorithm.PROMPTIM:
        return <PromptimConfig />;
      default:
        return null;
    }
  };

  return (
    <>
      {renderAlgorithmConfig()}
      <ModalButtons
        cta="Start Optimization"
        ctaButtonType="submit"
        isLoading={isOptimizeLoading}
        onCancel={onClose}
        onBack={prevStep}
      />
    </>
  );
};

const DemoConfig = () => {
  return (
    <div className="flex flex-col gap-2">
      <div>Demo config</div>
    </div>
  );
};
